// extracted by mini-css-extract-plugin
module.exports = {"odonto_neuquen__redText":"OdontoNeuquen_odonto_neuquen__redText__32Vl9","odonto_neuquen__image":"OdontoNeuquen_odonto_neuquen__image__wHoDS"};